import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function PointToPointLabel(props:any) {
	
	return (
	
		<SvgIcon  {...props} viewBox="0 0 18 3" >
		 
			<path d="M1.5 0C1.10218 0 0.720645 0.158036 0.43934 0.43934C0.158036 0.720645 0 1.10218 0 1.5C0 2.3325 0.675 3 1.5 3C2.3325 3 3 2.3325 3 1.5C3 1.10218 2.84196 0.720645 2.56066 0.43934C2.27936 0.158036 1.89782 0 1.5 0Z" fill="currentColor"/>
			<path d="M16.5 0C16.1022 0 15.7206 0.158036 15.4393 0.43934C15.158 0.720645 15 1.10218 15 1.5C15 2.3325 15.675 3 16.5 3C17.3325 3 18 2.3325 18 1.5C18 1.10218 17.842 0.720645 17.5607 0.43934C17.2794 0.158036 16.8978 0 16.5 0Z" fill="currentColor"/>
			<rect x="5" width="8" height="3" fill="currentColor"/>
		 
		</SvgIcon>
	
	)
}